module.exports = __webpack_public_path__ + "static/36-1c66f0dc4e583f94d0611d48fb0d62b7.png";